import React from 'react'

import { twm } from '../../lib/utils/twm'

export interface ButtonProps
  extends React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >,
    React.AriaAttributes {
  children: React.ReactNode
  flat?: boolean
  primary?: boolean
}

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  flat,
  primary,
  ...rest
}) => {
  return (
    <button
      {...rest}
      type="button"
      className={twm(
        'h-10 rounded bg-white px-4 font-body text-indigo-50 shadow-elevation-1 outline-1 outline-violet-50 hover:bg-gray-34 disabled:bg-gray-34 disabled:text-gray-50',
        flat && 'shadow-elevation-0',
        primary && 'bg-green-50 hover:bg-green-55',
        className,
      )}
    >
      {children}
    </button>
  )
}

export default Button
